import { toast } from '../toast';
import pubsub from '../base/pubsub';
import pushNotifier from '../base/push-notifier';
import { fileResourceId } from '../preview/file.js';

/* CHANNEL NOTIFICATIONS */
const commentsInPreview = () => {
    const previewNotifications = pushNotifier.listen('comment', 'v2');
    return {
        subscribe: () => {
            previewNotifications.subscribe(({event, data}) => {
                pubsub.publish(`files.comments.${data.event}.new`, data.comment);
            });
        },
        unsubscribe: () => previewNotifications.unsubscribe()
    };
};

const commentsInPresentations = () => {
    const presentationNotifications = pushNotifier.listen('comment', 'v2');
    return {
        subscribe: () => {
            presentationNotifications.subscribe(({event, data}) => {
                pubsub.publish(`presentations.comments.${data.event}.new`, data.comment);
            });
        },
        unsubscribe: () => presentationNotifications.unsubscribe()
    };
};

const getNotificationName = data => {
    let notification;

    if (data.action === 'mention') {
        notification = 'NEW_MENTION';
    } else if (data.event === 'comment') {
        notification = 'NEW_COMMENT';
    } else if (data.event === 'reply') {
        notification = 'NEW_REPLY';
    }

    return notification;
};

const handleFileNotification = data => {
    const file = data.comment.file;
    const notification = getNotificationName(data);

    const fileURL = fileResourceId.fromParams({
        storageType: file.storage_type,
        owner: file.owner,
        path: file.path,
        isShared: file.shared,
        srcId: file.src_id
    }, {
        comments: { show: true }
    }).asUrl();

    toast(notification, {
        id: fileURL,
        params: {
            name: data.comment.author.full_name,
            fileName: file.name,
            fileUrl: fileURL
        }
    });
};

const handleSlideNotification = data => {
    const notification = `${getNotificationName(data)}_SLIDE`;
    const slide = data.comment.slide;

    const path = data.comment.slide.presentation.owner === Settings.user.login
        ? '/portal/presentation/edit/'
        : '/presentations/';

    const slideUrl = `${path}${slide.presentation.uuid}/${slide.id}/?comments=true`;

    toast(notification, {
        id: slideUrl,
        params: {
            name: data.comment.author.full_name,
            slideName: slide.name,
            slideUrl: slideUrl
        }
    });
};

const trackCommentsInPortal = () => {
    pushNotifier
        .listen('comment', 'v2')
        .subscribe(({event, data}) => {
            if (data.comment.author.login === Settings.user.login) return;
            if (data.comment.resource_type === 'file') {
                handleFileNotification(data);
            } else {
                handleSlideNotification(data);
            }
        });
};

export default {
    commentsInPreview,
    commentsInPresentations,
    trackCommentsInPortal
};
